
<template>
    <div class="shimmer-table-loader">
        <div v-for="row in rowCount" :key="row" class="shimmer-row">
            <div class="shimmer-cell" v-for="column in columnCount" :key="column"></div>
        </div>
    </div>
</template>
  
<script>
export default {
    props: {
        rowCount: { type: Number, default: 5 },
        columnCount: { type: Number, default: 6 }
    }
};
</script>
  
<style scoped>
.shimmer-table-loader {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.shimmer-row {
    display: flex;
    gap: 12px;
    width: 100%;
    padding: 0.7rem 1rem;
}
.shimmer-table-loader:first-child {
    padding-top: 1.2rem;
}
.shimmer-table-loader:last-child {
    padding-bottom: 1.2rem;
}

.shimmer-cell {
    flex: 1;
    height: 20px;
    border-radius: 4px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e4e4e4 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.2s infinite linear;
}

@keyframes shimmer {
    0% {
        background-position: 200% 0;
    }

    100% {
        background-position: -200% 0;
    }
}
</style>
  
